export type TNativeAudioBufferConstructor = typeof AudioBuffer;
